"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeSubscription = void 0;
function closeSubscription(subscription) {
    if (subscription !== 'NOT_SET') {
        subscription.close();
    }
}
exports.closeSubscription = closeSubscription;
